/* Native scrolling, links and product forms work before this enhancement loads. */
if (!customElements.get('pk-product')) {
  customElements.define('pk-product', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.gallery = this.querySelector('.pk-gallery');
      const rank = (el) => (el.classList.contains('is-cover') ? 2 : el.classList.contains('is-lead') ? 1 : 0);
      this.shots = [...this.querySelectorAll('.pk-pdp__shot')].sort((a, b) => rank(b) - rank(a));
      this.current = 0;
      this.querySelector('.pk-gallery__controls')?.removeAttribute('hidden');
      this.addEventListener('click', (event) => this.handleClick(event), options);
      this.gallery?.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.syncGallery());
      }, { ...options, passive: true });
      this.gallery?.addEventListener('keydown', (event) => {
        if (event.target !== this.gallery || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        this.showImage(event.key === 'Home' ? 0 : event.key === 'End' ? this.shots.length - 1 : this.current + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      this.dialog = this.querySelector('dialog');
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      }, options);
      this.syncGallery();
      const buy = this.querySelector('.pk-buy');
      const bar = this.querySelector('[data-sticky-buy]');
      if (buy && bar && 'IntersectionObserver' in window) {
        this.io = new IntersectionObserver(([entry]) => {
          const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-in', show);
          bar.inert = !show;
        });
        this.io.observe(buy);
      }
    }

    disconnectedCallback() {
      this.io?.disconnect();
      this.events?.abort();
      this.request?.abort();
      cancelAnimationFrame(this.frame);
    }

    showImage(index) {
      if (!this.shots.length) return;
      const shot = this.shots[(index + this.shots.length) % this.shots.length];
      this.gallery.scrollTo({ left: shot.offsetLeft - this.shots[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }

    syncGallery() {
      if (!this.gallery || !this.shots.length) return;
      this.current = this.shots.reduce((closest, shot, index) => Math.abs(shot.getBoundingClientRect().left - this.gallery.getBoundingClientRect().left) < Math.abs(this.shots[closest].getBoundingClientRect().left - this.gallery.getBoundingClientRect().left) ? index : closest, 0);
      const count = this.querySelector('[data-gallery-count]');
      if (count) count.textContent = `${this.current + 1} / ${this.shots.length}`;
      this.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
        if (thumb.dataset.galleryThumb === this.shots[this.current].dataset.mediaId) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
    }

    handleClick(event) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const thumb = event.target.closest('[data-gallery-thumb]');
      if (thumb) {
        event.preventDefault();
        this.showImage(this.shots.findIndex((shot) => shot.dataset.mediaId === thumb.dataset.galleryThumb));
      }
      const qty = event.target.closest('[data-qty-step]');
      if (qty) {
        const input = this.querySelector('.pk-qty');
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(qty.dataset.qtyStep));
        return;
      }
      const step = event.target.closest('[data-gallery-step]');
      if (step) this.showImage(this.current + Number(step.dataset.galleryStep));
      const zoom = event.target.closest('[data-zoom]');
      if (zoom && this.dialog?.showModal) {
        event.preventDefault();
        const image = this.dialog.querySelector('img');
        image.src = zoom.href;
        image.alt = zoom.closest('figure').querySelector('img').alt;
        this.dialog.showModal();
      }
      const variant = event.target.closest('[data-variant-link]');
      if (variant && !variant.hasAttribute('aria-current')) {
        event.preventDefault();
        this.changeVariant(variant.href);
      }
    }

    async changeVariant(href) {
      this.request?.abort();
      const request = new AbortController();
      this.request = request;
      this.setAttribute('aria-busy', 'true');
      this.querySelector('.pk-buy__submit').disabled = true;
      const url = new URL(href);
      url.searchParams.set('section_id', this.dataset.sectionId);
      try {
        const response = await fetch(url, { signal: request.signal });
        if (!response.ok) throw new Error('No se pudo actualizar la variante.');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const updated = html.querySelector('pk-product');
        if (!updated || !updated.querySelector('input[name="id"]')) throw new Error('La respuesta no contiene el producto.');
        this.replaceWith(updated);
        history.replaceState(history.state, '', href);
        document.dispatchEvent(new CustomEvent('pk:product-updated'));
        updated.querySelector('[data-variant-link][aria-current]')?.focus({ preventScroll: true });
      } catch (error) {
        if (error.name !== 'AbortError') location.assign(href);
      }
    }
  });
}
